import { Trans } from '@lingui/react/macro';

import { Button } from '@/components/buttons';

type Props = {
  isEditMode: boolean;
  isSaveEnabled: boolean;
  isSaving: boolean;
  onEditModeChange: (isEditMode: boolean) => void;
  onCancel: () => void;
};

const CompanySettingsActionBar = ({
  isEditMode,
  isSaveEnabled,
  isSaving,
  onEditModeChange,
  onCancel,
}: Props) => {
  return (
    <div className="sticky top-0 z-5 -m-4 -mx-8 flex justify-end gap-4 bg-white p-4 px-8">
      {isEditMode ? (
        <>
          <Button disabled={isSaving} onClick={onCancel}>
            <Trans>Cancel</Trans>
          </Button>
          <Button variant="primary" isLoading={isSaving} disabled={!isSaveEnabled} type="submit">
            <Trans>Save Settings</Trans>
          </Button>
        </>
      ) : (
        <Button onClick={() => onEditModeChange(true)}>
          <Trans>Edit Settings</Trans>
        </Button>
      )}
    </div>
  );
};

export default CompanySettingsActionBar;
